import { t } from '@framework/i18n/intl/i18next.ts';

export function getDinamicButtonProps(
  textBefore?: string,
  textAfter?: string,
  selected?: boolean,
): { buttonText: string } {
  // Testo prima della selezione
  const before =
    textBefore && textBefore.trim().length > 0
      ? textBefore
      : t('widgets.advanced-single-select.select-button-text', 'Scegli');
  // Testo dopo la selezione
  const after =
    textAfter && textAfter.trim().length > 0
      ? textAfter
      : t('widgets.advanced-single-select.change-button-text', 'Cambia');

  const buttonText = selected ? after : before;

  return { buttonText };
}
